<div class="flex min-h-[100%]">
  <div #backdrop [style.pointerEvents]="appLayoutService.isSidebarOpened() ? 'auto' : 'none'" [style.opacity]="appLayoutService.isSidebarOpened() ? '1' : '0'"
    (click)="appLayoutService.toggleSidebar()"
    class="z-40 md:hidden fixed top-0 left-0 w-full h-full bg-black/40 transition-opacity duration-200">
  </div>

  <div #simulatedSidebarGap [style.width]="appLayoutService.isSidebarOpened() ? 'var(--sidebar-width)' : '0px'"
    [style.minWidth]="appLayoutService.isSidebarOpened() ? 'var(--sidebar-width)' : '0px'"
    class="h-full transition-all duration-500 hidden md:block">
  </div>

  <div #realSidebar
    [style.transform]="appLayoutService.isSidebarOpened() ? 'translateX(0px)' : 'translateX(calc(var(--sidebar-width) * -1))'"
    class="p-5 pr-2 z-50 fixed top-0 w-[var(--sidebar-width)] bg-white md:bg-transparent h-full transition-all duration-500">
    <app-sidebar-content></app-sidebar-content>
  </div>


  <div #gift class="max-w-screen-xl mx-auto md:p-4 flex-1 min-h-[100%] min-w-0 w-full">
    <div class="min-h-[100%] rounded-xl bg-white shadow-sm md:border border-gray-100 w-full">
      <div #myheader class="p-4 pb-0 max-md:sticky max-md:top-0 max-md:bg-white/80 max-md:backdrop-blur-sm max-md:z-10">
        <div class="flex items-center gap-1">
          <div class="flex-1 flex items-center">

            <div (click)="appLayoutService.toggleSidebar()" class="cursor-pointer pr-2 py-2">
              <ng-icon style="display: block;" size="18px" name="lucidePanelLeft"></ng-icon>
            </div>

            <div class="mr-2  border-l h-3 border-gray-200"></div>

            <span class="text-base font-medium text-gray-800">{{ appLayoutService.currentRouteName() }}</span>
          </div>


          <button class="get-gift-with-colleague-button app-button" (click)="onGetGiftWithColleagueButtonClick()">
            <span>
              Zsebeljetek be <span style="white-space: nowrap; font-weight:bold;">25-25</span> ezer forintot!
            </span>
            <img class="get-gift-with-colleague-button-icon" src="assets/images/svg/gift-package.svg" />
          </button>

        </div>

        <div class="border-b mt-4 h-full border-gray-200/80">

        </div>
      </div>
      <div class="p-4 md:p-8">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

</div>
